import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  createTaxTable,
  deleteTaxTableById,
  getTaxTablesByCompanyId,
  updateTaxTableById,
} from '@/services';
import { TaxTableType } from '@/types';

export const taxTableSlice = createApi({
  reducerPath: 'taxTable',
  tagTypes: ['taxTable', 'tax'],
  baseQuery: fetchBaseQuery(),
  endpoints: (builder) => ({
    getTaxTables: builder.query<any[] | undefined, string>({
      queryFn: async (companyId) => {
        const data = await getTaxTablesByCompanyId(companyId);
        return { data };
      },
      providesTags: [{ type: 'taxTable' }],
    }),
    createTaxTable: builder.mutation<TaxTableType | undefined, Partial<TaxTableType>>({
      queryFn: async (taxtable) => {
        const data = await createTaxTable(taxtable);
        return { data };
      },
      invalidatesTags: [{ type: 'taxTable' }],
    }),
    updateTaxTable: builder.mutation<
      TaxTableType | undefined,
      { taxTableId: string; updateData: Partial<TaxTableType> }
    >({
      queryFn: async ({ taxTableId, updateData }) => {
        const data = await updateTaxTableById(taxTableId, updateData);
        return { data };
      },
      invalidatesTags: [{ type: 'taxTable' }, 'tax'],
    }),
    deleteTaxTable: builder.mutation<boolean, string>({
      queryFn: async (taxtableId) => {
        const success = await deleteTaxTableById(taxtableId);
        return { data: success };
      },
      invalidatesTags: [{ type: 'taxTable' }],
    }),
  }),
});

export const {
  useGetTaxTablesQuery,
  useCreateTaxTableMutation,
  useUpdateTaxTableMutation,
  useDeleteTaxTableMutation,
} = taxTableSlice;
